// extracted by mini-css-extract-plugin
export var banner = "Hero-module--banner--Gu+CS";
export var bannerImg = "Hero-module--bannerImg--wugHZ";